export const stream = {
  stream: {
    addStream: 'Add Stream',
    button: {
      addStream: 'ADD STREAM',
    },
    dropdown: {
      statistics: 'STATISTICS',
    },
    videoEncoderH264Required: 'H.264 video encoder required',
    audioEncoderOpusRequired: 'Opus audio encoder required',
    stream: 'Stream',
    recordAutoStart: 'Auto-start',
    viewRecording: 'View Recording',
    tableHeader: {
      streamName: 'Stream Name',
      connection: 'Connection',
      protocol: 'Protocol',
      status: 'Status',
    },
    sections: {
      path1: 'Path 1',
      path2: 'Path 2',
      sap: 'SAP',
      source: 'SOURCE',
      parameters: 'STREAMING PARAMETERS',
      srtSettings: 'SRT SETTINGS',
      destination: 'DESTINATION',
      destinationWhip: 'DESTINATION',
      srtAccessControl: 'SRT ACCESS CONTROL',
      linkParameters: 'LINK PARAMETERS',
      recording: 'RECORDING PARAMETERS',
      recordingToggle: 'Recording',
    },
    srtRedundancyOptions: {
      none: 'None',
      optional: 'Optional',
      active: 'Active-Active',
      backup: 'Active-Backup',
    },
    states: {
      0: 'STOPPED',
      1: 'STREAMING',
      2: 'FAILED',
      3: 'CONNECTING',
      4: 'SECURING',
      5: 'LISTENING',
      6: 'PAUSED',
      7: 'PUBLISHING',
      8: 'RESOLVING',
      9: 'SCRAMBLED',
      10: 'CONNECTED',
      11: 'INITIALIZING',
    },
    pidAutoAssigned: 'Auto-Assign',
    srtListenerSecondPortPlaceholder: 'Optional',
    showTsFields: 'TS Settings',
    enums: {
      encapsulation: {
        2: 'TS over UDP',
        3: 'TS over RTP',
        5: 'QuickTime',
        16: 'RTMP',
        34: 'TS over SRT',
        64: 'RTSP',
        128: 'WHIP', // 0x00000080
      },
      shaping: {
        vbr: 'VBR',
        cvbr: 'CVBR',
        cbr: 'CBR',
      },
      fecRtp: {
        0: '(None)',
        2: 'Pro-MPEG FEC',
      },
      level: {
        0: 'A (Column Only)',
        1: 'B (Row and Column)',
      },
      metadataEncapsulation: {
        0: 'Synchronous',
        1: 'Asynchronous',
        2: 'Async with Sync AU',
      },
      srtMode: {
        0: 'Caller',
        1: 'Listener',
        2: 'Rendezvous',
      },
      encKeyLength: {
        0: '(None)',
        16: 'AES-128',
        32: 'AES-256',
      },
      authentication: {
        none: '(None)',
        auto: 'Auto',
        'AES-GCM': 'AES-GCM',
      },
      recording: {
        format: {
          mp4: 'MP4',
          ts: 'TS',
        },
        limitType: {
          '': '(None)',
          none: '(None)',
          time: 'Time',
          size: 'Size',
        },
        limitSizeUnit: {
          MB: 'MB',
          GB: 'GB',
        },
        segmentType: {
          '': '(None)',
          none: '(None)',
          time: 'Time',
          size: 'Size',
        },
        segmentSizeUnit: {
          MB: 'MB',
          GB: 'GB',
        },
      },

      srtRedundancyMode: {
        0: 'None',
        1: 'Optional',
        2: 'Active-Active',
        3: 'Active-Backup',
      },
      srtRedundancyRoleOptions: {
        primary: 'Primary',
        secondary: 'Secondary',
      },
      srtRedundancyPath1Role: {
        primary: 'Primary',
        secondary: 'Secondary',
      },
      networkInterface: {
        auto: 'Auto',
        eth0: 'eth0',
        eth1: 'eth1',
      },
      srtRedundancyPath1NetworkInterface: {
        auto: 'Auto',
        eth0: 'eth0',
        eth1: 'eth1',
      },
      srtRedundancyPath2NetworkInterface: {
        auto: 'Auto',
        eth0: 'eth0',
        eth1: 'eth1',
      },
      srtAccessControlPublishingIdType: {
        custom: 'Custom',
        standard: 'Standard Keys',
      },
    },
    unnamedStream: '(None)',
    defaultListAddress: '(any)',
    defaultPort: '(none)',
    srtAccessControlSwitch: 'SRT Access Control',
    fields: {
      adaptive: 'Dynamic Bitrate Control',
      address: 'Address',
      audio: 'Audio',
      authentication: 'Authentication',
      bandwithEstimate: 'Average Bandwidth',
      bearerToken: 'Bearer Token',
      encapsulation: 'Protocol',
      url: 'URL',
      urlHint: 'https://...',
      fecRtp: 'FEC',
      level: 'FEC Level',
      columns: 'FEC Columns',
      columnsExplainA: '1 - 20',
      columnsExplainB: '4 - 20',
      rows: 'FEC Rows',
      rowsExplain: '4 - 20',
      blockAligned: 'FEC Block Aligned',
      passphrase: 'Passphrase',
      metadata: 'Metadata',
      metadataBandwidth: 'Metadata Bandwidth',
      overheadPercentage: 'Bandwidth Overhead (%)',
      overheadPercentageExplain: '5 - 100',
      overheadPercentageSrtExplain: '5 - 50',
      mtu: 'MTU',
      mtuExplain: '268 - 1500',
      ttl: 'TTL',
      ttlExplain: '1 - 255',
      tos: 'ToS',
      tosExplain: '0x00 - 0xFF',
      scte: 'SCTE 35',
      stillImage: 'Still Image',
      audioPids: 'Audio PID',
      audioPidsExplain: '16 - 8190',
      videoPids: 'Video PID',
      videoPidsExplain: '16 - 8190',
      metadataPids: 'Metadata PID',
      metadataPidsExplain: '16 - 8190',
      sctePids: 'SCTE 35 PID',
      sctePidsExplain: '16 - 8190',
      pcrPid: 'PCR PID',
      pcrPidExplain: '16 - 8190',
      pmtPid: 'PMT PID',
      pmtPidExplain: '16 - 8190',
      tsStreamId: 'TS ID',
      tsStreamIdExplain: '0 - 65535',
      sap: {
        advertise: 'Transmit SAP',
        name: 'Name',
        desc: 'Description',
        author: 'Author',
        keywords: 'Keywords',
        copyright: 'Copyright',
        address: 'Address',
        port: 'Port',
      },
      shaping: 'Timing & Shaping',
      programNumber: 'Program Number',
      programNumberExplain: '1 - 65535',
      encKeyLength: 'Encryption',
      bitrate: 'Bitrate',
      protocol: 'Protocol',
      recording: {
        autoStart: 'Auto-Start',
        format: 'Format',
        name: 'File Name',
        limitSize: 'Size Limit',
        limitSizeUnit: 'Unit',
        limitHour: 'Hours',
        limitMinutes: 'Min',
        limitType: 'Limit Type',
        limitSizeHour: 'Hours',
        limitSizeMinutes: 'Min',
        recycleSegments: 'Segmentation Rollover',
        segmentType: 'Recording Segmentation',
        segmentSize: 'Size Limit',
        segmentSizeUnit: 'Unit',
        segmentHour: 'Hours',
        segmentMinutes: 'Min',
      },
      recordAutoStart: 'Auto-Start',
      recordFormat: 'Format',
      recordName: 'File Name',
      recordLimitSize: 'Size Limit',
      recordLimitSizeUnit: 'Unit',
      recordSegmentationSize: 'Size Limit',
      recordSegmentationSizeUnit: 'Unit',
      recordLimitHour: 'Hours',
      recordLimitMinutes: 'Min',
      recordLimitType: 'Limit Type',
      recordLimitTimeHour: 'Hours',
      recordLimitTimeMinutes: 'Min',
      recordSegmentation: 'Recording Segmentation',
      recordSegmentationHour: 'Hours',
      recordSegmentationMinutes: 'Min',
      recordSegmentationRollover: 'Segmentation Rollover',
      type: 'Type',
      typeSelectOptions: {
        multicast: 'Multicast',
        unicast: 'Unicast',
      },
      port: 'Port',
      portExplain: '1 - 65535',
      portNumberRTPExplain: '2 - 65534',
      srtListenerSecondPort: 'Alternate Port',
      fec: 'FEC',
      fecSelectOptions: {
        0: 'None',
        2: 'Pro-MPEG',
      },
      latency: 'Latency (ms)',
      latencyExplain: '20 - 8000',
      metadataEncapsulation: 'Data Carriage',
      multicastAddress: 'Multicast Address',
      multicastAddressTextfieldPlaceholder: '',
      sourceAddress: 'Source Address',
      sourceAddressTextfieldPlaceholder: 'Optional',
      rtspAddress: 'RSTP URL',
      rtspAddressTextfieldPlaceholder: 'rtsp://',
      video: 'Video',
      srtMode: 'Mode',
      srtRedundancyMode: 'Path Redundancy',
      networkInterface: 'Network Interface',
      srtRedundancyPath1Name: 'Path Name',
      srtRedundancyPath2Name: 'Path Name',
      srtRedundancyPath1NamePlaceholder: 'Optional Descriptive Label',
      srtRedundancyPath2NamePlaceholder: 'Optional Descriptive Label',
      srtRedundancyPath1Address: 'Address',
      srtRedundancyPath2Address: 'Address',
      sourcePort: 'Source Port',
      srtRedundancyPath1SourcePort: 'Source Port',
      srtRedundancyPath2SourcePort: 'Source Port',
      srtRedundancyPath1SourcePortPlaceholder: 'Auto-Assign',
      srtRedundancyPath2SourcePortPlaceholder: 'Auto-Assign',
      srtRedundancyPath1Port: 'Destination Port',
      srtRedundancyPath2Port: 'Destination Port',
      srtRedundancyPath1Role: 'Path Role',
      pathRole: 'Path Role',
      // srt publishing id
      srtAccessPublishingID: 'Stream Publishing ID',
      srtAccessUserName: 'User Name',
      srtAccessResourceName: 'Resource Name',
      srtAccessControlPublishingIdType: 'Format',
      srt: {
        address: 'Address',
        addressTextfieldPlaceholder: '',
        sourcePort: 'Source Port',
        sourcePortTextfieldPlaceholder: 'Auto-Assign',
        destinationPortTextfieldLabel: 'Destination Port',
        destinationPortTextfieldPlaceholder: '',
        flipToUdpHeaderTitle: 'STREAM CONVERSION',
        latency: 'Latency (ms)',
        latencyTextfieldPlaceholder: '',
        encrypted: 'Encrypted',
        passphrase: 'Passphrase',
        strictMode: 'Reject Unencypted Callers',
        srtUdpStreamConversion: 'SRT to UDP Stream Conversion',
        ttl: 'TTL',
        ttlTextfieldPlaceholder: '',
        tos: 'ToS',
        tosTextfieldPlaceholder: '',
      },
    },
    deleteModal: {
      title: 'Delete this stream?',
      title_plural: 'Delete {{count}} streams?',
    },
    notifications: {
      addError: 'Stream "{{name}}" could not be added',
      addRecordError: 'Record "{{name}}" could not be added',
      addErrorEmptyName: 'Stream could not be added',
      addRecordErrorEmptyName: 'Record could not be added',
      addSuccess: 'Stream "{{name}}" created successfully',
      addRecordSuccess: 'Stream "{{name}}" created successfully',
      addSuccessEmptyName: 'Stream created successfully',
      addRecordSuccessEmptyName: 'Record created successfully',
      clearStatsSuccess: "Statistics of '{{name}}' cleared",
      clearStatsSuccessEmptyName: 'Statistics cleared',
      createSuccess: "Stream '{{name}}' created successfully",
      createSuccessEmptyName: 'Stream created',
      deleteError_plural: '{{count}} streams could not be deleted',
      deleteError: '{{count}} stream could not be deleted',
      deleteRecordErrorEmptyName: 'Record could not be deleted',
      startError_plural: '{{count}} streams could not be started',
      startError: '{{count}} stream could not be started',
      stopError_plural: '{{count}} streams could not be stopped',
      stopError: '{{count}} stream could not be stopped',
      updateError: "Stream '{{name}}' could not be updated",
      updateErrorEmptyName: 'Stream could not be updated',
      updateSuccess: "Stream '{{name}}' updated",
      updateSuccessEmptyName: 'Stream updated',
      updateRecordSuccessEmptyName: 'Record updated successfully',
      updateRecordSuccess: 'Record "{{name}}" updated successfully',
      updateRecordErrorEmptyName: 'Record could not be updated',
      updateRecordError: 'Record "{{name}}" could not be updated',
    },
    noContent: {
      title: 'No Streams Configured',
      subText: 'Add a stream to start your journey',
      btnText: 'Add Stream',
    },
    row: {
      networkInterface: {
        auto: 'Auto',
        eth0: 'Eth 0',
        eth1: 'Eth 1',
      },
      recording: 'Recording',
    },
    tooltips: {
      adaptiveOffRedundant: 'Dynamic Bitrate Control is not available for SRT redundant streams',
      clickToStop: 'Stop Recording',
      clickToStart: 'Start Recording',
    },
  },
};
